import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';

import { excelStyles } from '../../../components/Grid/ExcelStyles/excelStyles';
import { getAllRegistries } from '../../../api/registries';
import LoadRowsComponent from '../../../helpers/LoadRowsComponent';
// import StudyLinkForeignKey from '../../components/Grid/CellRenderer/StudyLinkForeignKey';
import TotalRow from '../../../components/Grid/CellRenderer/TotalRow';

const RegistriesGridReadOnly = ({
  registriesList,
  onRowClicked,
  onDeleteClicked,
  search,
  setRefresh,
  refresh,
  sort = "",
  setSort = () => {},
  isStudyDetail = false,
}) => {
  // const [rowData, setRowData] = useState(registriesList);
  console.log(registriesList, 'rl')
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState(registriesList ? registriesList.length : 0);

  useEffect(() => {
    if(registriesList){
      setTotalRows(registriesList.length)
    }
  }, [registriesList]);

  useEffect(() => {
    if(refresh){
      let refreshOptions = {}
      // if adding the first row, purge for item to properly refresh
      if (gridApi.getDisplayedRowCount() === 0) refreshOptions = { purge: true };
      gridApi.refreshServerSideStore(refreshOptions);
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if(gridApi){
      //loads in more rows while scrolling
      const dataSource = {
        getRows: function(params) {
          let sortParam = "";
          if(params.request.sortModel.length !== 0){
            const sortColumn = params.request.sortModel[0].colId;
            const sortWay = params.request.sortModel[0].sort;
            if(sortWay === "desc"){
              sortParam += "-";
            }
            if(sortColumn === "global_registry_name"){
              sortParam += `global_registry__name`
            }
            else{
              sortParam += sortColumn;
              sortParam = sortParam.replaceAll(".", "__");
            }
          }
          if(sortParam){
            setSort(sortParam);
          }
          else{
            setSort("");
          }
          const rows = getAllRegistries({limit: 100, offset: params?.request.startRow, search: search, sort: sortParam})
            .then( res => {
              setTotalRows(res.count);
              params.success({
                rowData: res.results,
                rowCount: res.count
              })
              if(res.count === 0){
                gridApi.showNoRowsOverlay();
              }
            });
        }
      };
      gridApi.setServerSideDatasource(dataSource);
    }
  }, [gridApi, search, sort]);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // const cellClicked = (event) => {
  //   const { cellRenderer } = event.colDef;
  //   if (cellRenderer !== "removeRow") {
  //     onRowClicked(event.data);
  //   }
  // };

  // const deleteRow = (itemId) => {
  //   onDeleteClicked(itemId);
  // };

  const gridOptions = {
    columnDefs: [
      // {
      //   headerName: 'Study ID',
      //   field: 'study',
      // },
      {
        headerName: 'Global Registry',
        field: 'global_registry_name',
        flex: '1'
      },
      {
        headerName: 'Registry ID',
        field: 'registry_id',
        flex: '1'
      },
      {
        headerName: 'Summary Page URL',
        field: 'trial_summary_page_url',
        flex: '1'
      },
      {
        headerName: 'Results Page URL',
        field: 'results_page_url',
        flex: '1'
      },
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    excelStyles,
    frameworkComponents: {
      LoadRowsComponent: LoadRowsComponent,
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  };

  return (
    <Container className="ag-theme-balham">
      { isStudyDetail
        &&
        <AgGridReact
          onGridReady={onGridReady}
          gridOptions={gridOptions}
          // onCellClicked={event => cellClicked(event)}
          rowData={registriesList}
        ></AgGridReact>
      
      }
      <TotalRow count={totalRows} />
    </Container>
  );
};

export default RegistriesGridReadOnly;

const Container = styled.div`
flex: 1 1 auto;
padding-bottom: 20px;
`
